import { useCallback } from 'react';

import { Button } from '@bambi/component-library/src/components/Button';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';

import { useAppDispatch } from 'src/app/store/hooks';
import { useTilledResourceLinkCreateMutation } from 'src/common/external/bambi-api/bambiApi';
import { show } from 'src/common/primitives/Toast/toast.slice';
import formatServerError from 'src/common/util/serverErrorFormatter';

interface ViewOnTilledCellProps {
  resourceId: string;
  type: 'payments' | 'refunds';
}

export function ViewOnTilledCell({ resourceId, type }: ViewOnTilledCellProps) {
  const [createTilledResourceLink] = useTilledResourceLinkCreateMutation();
  const dispatch = useAppDispatch();

  const handleCreateTilledResourceLink = useCallback(async () => {
    try {
      const result = await createTilledResourceLink({
        tilledResourceLink: {
          type,
          id: resourceId,
        },
      }).unwrap();

      window.open(result.url, 'tilled-resource-link', 'popup');
    } catch (error) {
      dispatch(
        show({
          type: 'error',
          title: 'Unable to create Tilled resource link',
          description: formatServerError(error),
        })
      );
    }
  }, [createTilledResourceLink, resourceId, type]);

  return (
    <div className="flex flex-row justify-end print:hidden">
      <Button variant="ghost-icon" onClick={handleCreateTilledResourceLink}>
        <div
          className="flex flex-col items-center text-xs"
          style={{
            fontSize: '0.625rem',
          }}
        >
          <ArrowTopRightOnSquareIcon className="w-6" />
          View
        </div>
      </Button>
    </div>
  );
}
